import { createContext, useContext, useState } from "react";
import Login from "../page/auth/Login";
import Register from "../page/auth/Register";
import ForgotPassword from "../page/auth/ForgotPassword";
import ResetPassword from "../page/auth/ResetPassword";

const AuthModalContext = createContext(null);

export const AuthModalProvider = ({ children }) => {
  const [view, setView] = useState(null); // null | "login" | "register" | "forgot-password" | "reset-password"
  const [modalData, setModalData] = useState(null);

  const openModal  = (v = "login", data = null) => { setView(v); setModalData(data); };
  const closeModal = () => { setView(null); setModalData(null); };
  const switchView = (v, data = null) => { setView(v); setModalData(data); };

  return (
    <AuthModalContext.Provider value={{ view, openModal, closeModal, switchView }}>
      {children}

      {/* Modal overlay — renders on top of any page */}
      {/* Backdrop click does NOT close the modal — users must use the X button. */}
      {view && (
        <div
          style={{
            position: "fixed", inset: 0, zIndex: 200,
            background: "rgba(0,0,0,0.65)",
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: 16,
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              maxWidth: view === "register" ? 480 : 420,
              margin: "0 auto",
              borderRadius: 16,
              overflow: "hidden",
              boxShadow: "0 40px 120px rgba(0,0,0,0.8)",
            }}
          >
            {/* Close button */}
            <button
              onClick={closeModal}
              style={{
                position: "absolute",
                top: 14, right: 14, zIndex: 10,
                width: 28, height: 28, borderRadius: "50%",
                background: "#f3f4f6", border: "1px solid #e5e7eb",
                display: "flex", alignItems: "center", justifyContent: "center",
                cursor: "pointer", color: "#6b7280",
              }}
            >
              <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {view === "login"           && <Login isModal onClose={closeModal} onSwitch={switchView} modalEmail={modalData?.email} modalPassword={modalData?.password} />}
            {view === "register"        && <Register isModal onClose={closeModal} onSwitch={switchView} />}
            {view === "forgot-password" && <ForgotPassword isModal onSwitch={switchView} onClose={closeModal} />}
            {view === "reset-password"  && <ResetPassword isModal modalEmail={modalData?.email} modalToken={modalData?.token} onClose={closeModal} onSwitch={switchView} />}
          </div>
        </div>
      )}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = () => useContext(AuthModalContext);
